export class BrightnessMetricModel {
  ag!: string[];
  avg!: Nullable<string>;
  d!: number;
  faceup!: Nullable<string>;
  hr!: string;
  singleHr!: string;
  rg!: number;
  rg2!: number;
  val!: Nullable<string>;
  val2!: Nullable<string>;
  ver!: string;
  gmc!: number;
  gmc2!: number;
}

export default class BrightnessMetric extends BrightnessMetricModel {
  constructor({ ag, avg, d, faceup, hr, singleHr, rg, rg2, val, val2, ver, gmc, gmc2 }: BrightnessMetricModel) {
    super();

    this.ag = ag;
    this.avg = avg ? Number(avg).toFixed(2) : null;
    this.d = d;
    this.faceup = faceup ? Number(faceup).toFixed(2) : null;
    this.hr = hr;
    this.singleHr = singleHr;
    this.rg = rg;
    this.rg2 = rg2;
    this.val = val ? Number(val).toFixed(2) : null;
    this.val2 = val2 ? Number(val2).toFixed(2) : null;
    this.ver = ver;
    this.gmc = gmc;
    this.gmc2 = gmc2;
  }
}
